import './subheader.scss';
import React from 'react';
import { MMTInfo } from '../../config';

function Subheader() {
    return (
        <div className="subheader">
            <div className="container">
                <div className="content">
                    <a
                        href={`https://www.facebook.com/${MMTInfo.facebookId}/`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <div className="fb">Follow us on Facebook</div>
                    </a>
                    <div className="tel">{MMTInfo.phone}</div>
                </div>
            </div>
        </div>
    );
}

export default Subheader;
